const TIMEOUT_MEGAMENU = 150;
const MOBILE_BREAKPOINT = 1024;
class Megamenu extends HTMLElement {
  constructor() {
    super();
    this.megamenuEl = this;
    this.sectionHeader = document.querySelector("#shopify-section-header");
    this.mainNavigation = document.querySelector(this.getAttribute("navigation-main"));
    this.mainHeader = document.querySelector(this.getAttribute("header-main"));
    this.submenus = this.querySelectorAll(".megamenu-submenu");
    if (this.mainNavigation === null || this.mainHeader === null) {
      throw new Error("Main navigation or/and main header are undefined");
    }
    this.mobileBreakpoint = MOBILE_BREAKPOINT;
    this.mainNavigationItems = this.mainNavigation.querySelectorAll("a");
    this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
    if (this.mainNavigationItems.length > 0 && !this.isMobile) {
      this.getSubmenuMaxHeight(100);
      this.bindEvents();
    }
  }
  bindEvents() {
    for (let i = 0; i < this.mainNavigationItems.length; i++) {
      this.mainNavigationItems[i].addEventListener("mouseenter", (e) => {
        this.megamenuEnterTimeout = setTimeout(() => {
          this.mainNavigationMouseenterHandler(this.mainNavigationItems[i]);
        }, TIMEOUT_MEGAMENU);
      });
      this.mainNavigationItems[i].addEventListener("mouseleave", () => {
        clearTimeout(this.megamenuEnterTimeout);
      });
    }
    document.addEventListener("mouseover", (e) => {
      if (e.target.closest("#shopify-section-header") || e.target.closest("#shopify-section-megamenu")) {
        clearTimeout(this.megamenuTimeout);
      } else {
        this.startTimeout();
      }
    });
  }
  startTimeout() {
    this.megamenuTimeout = setTimeout(() => {
      this.mainHeader.classList.remove("header--megamenu-active");
      document.body.classList.remove("megamenu-visible");
      this.hideMegamenu();
      this.hideSubmenus();
    }, TIMEOUT_MEGAMENU);
  }
  mainNavigationMouseenterHandler(element) {
    const target = element.dataset.tabHandle;
    const submenuTarget = this.querySelector('[data-tab-handle="' + target + '"]');
    this.currentTab = target;
    this.setActiveTabOnMainHeader();
    if (submenuTarget) {
      clearTimeout(this.megamenuTimeout);
      this.hideSubmenus();
      this.mainHeader.classList.add("header--megamenu-active");
      document.body.classList.add("megamenu-visible");
      this.classList.add("megamenu-items--visible");
      submenuTarget.classList.add("megamenu-submenu--visible");
    } else {
      this.startTimeout();
    }
  }
  hideMegamenu() {
    this.classList.remove("megamenu-items--visible");
  }
  hideSubmenus() {
    for (let i = 0; i < this.submenus.length; i++) {
      this.submenus[i].classList.remove("megamenu-submenu--visible");
    }
  }
  setActiveTabOnMainHeader() {
    const mainNavigationItems = this.mainNavigation.querySelectorAll("a");
    for (let i = 0; i < mainNavigationItems.length; i++) {
      mainNavigationItems[i].classList.remove("navigation-header__link--active");
    }
    this.mainNavigation.querySelector('[data-tab-handle="' + this.currentTab + '"]').classList.add("navigation-header__link--active");
  }
  getSubmenuMaxHeight(extraHeight = 0) {
    let maxHeight = 0;
    this.submenus.forEach((submenu) => {
      maxHeight = Math.max(maxHeight, submenu.offsetHeight);
    });
    this.megamenuEl.style.setProperty("--submenu-max-height", `${maxHeight + extraHeight}px`);
  }
}
customElements.define("w3-megamenu", Megamenu);
